module.exports = __webpack_public_path__ + "static/power3-2@2x-e55d5264ab7bf815cdd3a153cb6cbf45.png";